export const SkuOfferingStatus = {
  NEW_ITEM: 1,
  LIMITED_RELEASE: 2,
  EVERYDAY: 3,
  NOT_OFFERED: 4,
};